
/*
 * CARILLO MODA
 * Correlati automatici per codice tessuto
 *
 * Metafield: custom.codice_tessuto
 * Sezione: carillo-correlati-tessuto.liquid
 * Risultati: carillo-fabric-results.liquid
 *
 * Versione 1.1 - Correzione layout card
 *
 * Non modifica gli script originali del tema.
 */

(function () {
  'use strict';

  const SECTION_ID = 'carillo-fabric-results';
  const FILTER_NAME = 'filter.p.m.custom.codice_tessuto';
  const PAGE_LIMIT = 100;

  const initialized = new WeakSet();

  function getRoots(scope) {
    const roots = [];

    if (
      scope &&
      scope.matches &&
      scope.matches('[data-carillo-fabric-root]')
    ) {
      roots.push(scope);
    }

    if (scope && scope.querySelectorAll) {
      roots.push(
        ...scope.querySelectorAll(
          '[data-carillo-fabric-root]'
        )
      );
    }

    return roots;
  }

  function setStatus(root, message) {
    const status = root.querySelector(
      '[data-fabric-status]'
    );

    if (!status) return;

    status.textContent = message;
    status.hidden = !message;
  }

  function makeUrl(root, page) {
    const collectionPath =
      root.dataset.collectionUrl || '/collections/all';

    const url = new URL(
      collectionPath,
      window.location.origin
    );

    // Filtro per codice tessuto
    url.searchParams.set(
      FILTER_NAME,
      root.dataset.fabricCode
    );

    // Sezione Liquid dei risultati
    url.searchParams.set(
      'section_id',
      SECTION_ID
    );

    // Paginazione
    url.searchParams.set(
      'page',
      String(page)
    );

    // Mantiene il tema Shopify in anteprima
    const currentParams = new URLSearchParams(
      window.location.search
    );

    const previewThemeId = currentParams.get(
      'preview_theme_id'
    );

    if (previewThemeId) {
      url.searchParams.set(
        'preview_theme_id',
        previewThemeId
      );
    }

    return url;
  }

  async function fetchPage(root, page) {
    const url = makeUrl(root, page);

    const response = await fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html'
      }
    });

    if (!response.ok) {
      throw new Error(
        'Errore Shopify HTTP ' + response.status
      );
    }

    const html = await response.text();

    const documentResult = new DOMParser()
      .parseFromString(html, 'text/html');

    const results = documentResult.querySelector(
      '[data-carillo-fabric-results]'
    );

    if (!results) {
      throw new Error(
        'Sezione carillo-fabric-results non trovata'
      );
    }

    const productContainer = results.querySelector(
      '[data-fabric-products]'
    );

    const products = productContainer
      ? Array.from(
          productContainer.querySelectorAll(
            ':scope > article.product-item'
          )
        )
      : [];

    const next = results.querySelector(
      '[data-fabric-next-page]'
    );

    return {
      products: products,
      hasNext: Boolean(next)
    };
  }

  function productId(card) {
    return String(
      card.getAttribute('data-product-item') || ''
    );
  }

  function initializeThemeFeatures(root) {
    const container = root.querySelector(
      '[data-carillo-fabric-slider]'
    );

    if (!container) return;

    // Riattivazione swatch originali
    if (
      window.theme &&
      window.theme.swatches &&
      typeof window.Swatches === 'function'
    ) {
      try {
        const options = container.querySelectorAll(
          '.product-item [data-product-option]'
        );

        if (options.length) {
          window.Swatches(options, 'loop');
        }
      } catch (error) {
        console.warn(
          '[Carillo Tessuto] Errore swatch:',
          error
        );
      }
    }

    // Riattivazione quick view originale
    if (
      window.theme &&
      window.theme.quick &&
      typeof window.Quick === 'function'
    ) {
      try {
        new window.Quick();
      } catch (error) {
        console.warn(
          '[Carillo Tessuto] Errore quick view:',
          error
        );
      }
    }
  }

  function initializeNavigation(root) {
    const slider = root.querySelector(
      '[data-carillo-fabric-slider]'
    );

    const previous = root.querySelector(
      '[data-fabric-prev]'
    );

    const next = root.querySelector(
      '[data-fabric-next]'
    );

    if (!slider || !previous || !next) return;

    slider.classList.add('slider-loaded');

    function updateButtons() {
      const maxScroll = Math.max(
        0,
        slider.scrollWidth - slider.clientWidth
      );

      previous.disabled = slider.scrollLeft <= 2;

      next.disabled =
        slider.scrollLeft >= maxScroll - 2;

      const navigation = root.querySelector(
        '.carillo-fabric-nav'
      );

      if (navigation) {
        navigation.hidden = maxScroll <= 2;
      }
    }

    function scrollByCard(direction) {
      const card = slider.querySelector(
        'article.product-item'
      );

      if (!card) return;

      const cardWidth =
        card.getBoundingClientRect().width;

      const computedStyle = getComputedStyle(slider);

      const gap =
        parseFloat(computedStyle.columnGap) ||
        parseFloat(computedStyle.gap) ||
        20;

      slider.scrollBy({
        left: direction * (cardWidth + gap),
        behavior: 'smooth'
      });
    }

    previous.addEventListener('click', function () {
      scrollByCard(-1);
    });

    next.addEventListener('click', function () {
      scrollByCard(1);
    });

    slider.addEventListener(
      'scroll',
      updateButtons,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateButtons
    );

    requestAnimationFrame(updateButtons);
    setTimeout(updateButtons, 300);
  }

  async function initialize(root) {
    if (initialized.has(root)) return;

    initialized.add(root);

    const fabricCode = String(
      root.dataset.fabricCode || ''
    ).trim();

    const currentProductId = String(
      root.dataset.productId || ''
    );

    const maxItems = Math.max(
      1,
      Math.min(
        50,
        Number(root.dataset.maxItems) || 16
      )
    );

    if (!fabricCode) return;

    const slider = root.querySelector(
      '[data-carillo-fabric-slider]'
    );

    if (!slider) return;

    const seenProducts = new Set();
    seenProducts.add(currentProductId);

    const collectedProducts = [];

    let page = 1;
    let hasNext = true;

    try {
      // Recupera i prodotti con lo stesso codice tessuto
      while (
        hasNext &&
        page <= PAGE_LIMIT &&
        collectedProducts.length < maxItems
      ) {
        const result = await fetchPage(root, page);

        for (const card of result.products) {
          const id = productId(card);

          if (!id || seenProducts.has(id)) {
            continue;
          }

          seenProducts.add(id);
          collectedProducts.push(card);

          if (collectedProducts.length >= maxItems) {
            break;
          }
        }

        hasNext = result.hasNext;
        page++;
      }

      // Nessun correlato: nasconde la sezione
      if (!collectedProducts.length) {
        root.hidden = true;
        return;
      }

      /*
       * CORREZIONE LAYOUT
       *
       * Le classi di griglia vengono applicate
       * direttamente allo slider.
       *
       * Le card diventano figli diretti
       * del contenitore scorrevole.
       */

      slider.classList.add(
        'section-card-rows',
        'mobile-rows-of-2',
        'desktop-rows-of-4',
        'product-rows'
      );

      slider.replaceChildren(...collectedProducts);

      // Mostra la sezione
      root.hidden = false;

      // Riattiva le funzioni delle card
      initializeThemeFeatures(root);

      // Navigazione dello slider
      initializeNavigation(root);

      setStatus(root, '');

      console.info(
        '[Carillo Tessuto] Codice:',
        fabricCode,
        '| Prodotti:',
        collectedProducts.length,
        '| Pagine richieste:',
        page - 1
      );

    } catch (error) {
      root.hidden = true;

      console.error(
        '[Carillo Tessuto] Errore caricamento:',
        error
      );
    }
  }

  function initializeAll(scope) {
    const roots = getRoots(scope || document);

    roots.forEach(function (root) {
      initialize(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeAll(document);
      },
      { once: true }
    );
  } else {
    initializeAll(document);
  }

  // Supporto editor Shopify
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAll(event.target);
    }
  );

})();
